export const CENTS_FACTOR = 100n;
export const TWO_DECIMAL_PLACES = 2;
export const THREE_DECIMAL_PLACES = 3;
export const ONE_CENT = 1n;
export const ZERO_INT = 0;
